module.exports = __webpack_public_path__ + "static/media/analytics.8d43ad92.mp4";